import { ESpecialTabs } from '../../constants/specialTabs';
import { FDealType } from '../category';

export function isAddformTabEnabled(currentTab: FDealType | ESpecialTabs) {
  return currentTab === FDealType.Sale || currentTab === FDealType.RentLongterm;
}
